<template>
<van-uploader
  :multiple="false"
  accept=".jpg,.jpeg,.png,.gif,.mp4"
  :max-count="1"
  :after-read="handleFileChange"
  :max-size="1024 * 1024 * 20"
  @oversize="handleOversizeChange"
>
  <span class="chat__tool-item"><van-icon class="phone-icon" name="photo-o" size="26" /></span>
</van-uploader>
</template>

<script setup lang="ts">
import {
  uploadAttach,
  uploadFileByUrl,
  type IUploadFile
} from '@/api/models/reviews' 
import domain from '@/server-config/domain.config'

const emit = defineEmits<{
  (e: 'send:msg', data: {
    msgType: number,
    content: string,
    status: 'loading' | 'success' | 'fail',
    filename: string
  }): void
}>()
/**
 * 图片/视频
 */
 const handleOversizeChange = () => {
  showToast('The maximum file size is 20M.')
}

const handleFileChange = async (e: any) => {
  let msgType = 5
  if(/image/.test(e.file.type)) {
    msgType = 2
  }

  
  const { size, name, type } = e.file
  const suffix = name.split('.').pop()
  const filename = `${Date.now().toString()}.${suffix}`
  const params: IUploadFile = {
    file_size: size / 1024 / 1024,
    file_type: type === 'video/mp4' ? '2' : '1',
    filename,
    service_name: 'review'
  }
  e.status = 'uploading'
  
  emit('send:msg', { msgType, content: e.objectUrl, status: 'loading', filename })
  try {
    const { filename: uploadedFilename, url } = await uploadAttach(params)

    await uploadFileByUrl(url, e.file)

    e.status = ''
    const fullurl = `${domain.HW_OBS_UPLOAD}/${uploadedFilename}`

    emit('send:msg', { msgType, content: fullurl, status: 'success', filename })
  } catch(err) {
    console.error("🚀 ~ handleFileChange ~ err:", err)
    emit('send:msg', { msgType, content: e.objectUrl, status: 'fail', filename })
  }
}
</script>

<style lang="scss" scoped>
</style>
